module.exports = __webpack_public_path__ + "static/media/banner-rosa.d07bed80.jpg";